import queryString from 'query-string'
import MobileDetect from 'mobile-detect'
import Ajax from 'superagent'
import { keys, difference } from "lodash"

import { l } from "../../lib/Tools"

export function setUrlFragment(browserHistory, fragment) {
  const loc = browserHistory.getCurrentLocation()
  browserHistory.replace(`${loc.pathname}?${queryString.stringify(loc.query)}#${fragment}`)
}

export function getUrlFragment(browserHistory): string {
  return browserHistory.getCurrentLocation().hash
}

export function replaceQuery(history: Object, query: Object, changes: ?Object) {
  const loc = history.getCurrentLocation()
  history.replace(
    changes
      ? `${loc.pathname}?${queryString.stringify({ ...query, ...changes })}${loc.hash}`
      : `${loc.pathname}?${queryString.stringify(query)}${loc.hash}`
  )
}

export function getGeolocationParameters({nextAddress, currentAddress, nextCity, currentCity, nextName, currentName}) {
  console.log(`nextAddress : ${nextAddress}, currentAddress : ${currentAddress}`)
  if (nextCity && nextAddress && (nextCity != currentCity || nextAddress != currentAddress)) {
    return encodeURIComponent(`${nextAddress}, ${nextCity}`)
  }
  else if (!nextAddress && nextCity && nextName && (nextCity != currentCity || nextName != currentName)) {
    return encodeURIComponent(`${nextName}, ${nextCity}`)
  }
  else {
    return null
  }
}

export function fetchGeolocation(x) {
  return new Promise((resolve, reject) => {
    if (x) {
      console.log(`gonna look up: ${x}`)
      Ajax
        .get(`https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCqgRbFVinfn9W8m0O2zxxc_haZl895tN8&address=${x}`)
        .end((e, r) => {
          if (!e && r.body.results.length > 0) {
            const geolocation = r.body.results[0]
            resolve(geolocation)
          }
          else {
            const errorMsg = `error fetching directions ${r.body.status} (request error: ${JSON.stringify(e)})`
            console.error(errorMsg)
            reject(new Error(errorMsg))
          }
        })
    }
    else reject(new Error('Received empty parameter'))
  })
}

/**
 *
 */

const md = new MobileDetect(window.navigator.userAgent)
const mobile = (
  md.mobile() && (
    document.documentElement.clientWidth < 1024
    || document.documentElement.clientHeight < 1024)
)

export function isMobile() {
  return mobile
}

/**
 *
 */

// to debug why a component is updating when you wouldnt expect it to
//
// use:
//  shouldComponentUpdate(np, ns) {
//    return debug_shouldComponentUpdate(this.props, this.state, np, ns)
//  }

export function debugShouldComponentUpdate(op, os, np, ns) {
  const { name } = np.reservation

  const kos = keys(os).sort()
  const kns = keys(ns).sort()

  const kop = keys(op).sort()
  const knp = keys(np).sort()

  if (kos.length != kns.length) return !!l(`state length ${kos.length} => ${kns.length}`)
  if (kop.length != knp.length) return !!l("props length")

  if (difference(kns, kos).length > 0) return !!("diferent state keys")
  if (difference(knp, kop).length > 0) return !!("diferent props keys")

  let somethingChanged = false

  const compare = (k, a, b) => {
    const ov = a[k]
    const nv = b[k]
    if (ov != nv) {
      console.log(`${name}: ${k} ha cambiado`)
      console.log(ov)
      console.log(nv)
      somethingChanged = true
    }
  }

  kos.forEach(k => compare(k, os, ns))
  kop.forEach(k => compare(k, op, np))

  return somethingChanged
}
